import styled, { css } from 'styled-components';
import { getMargins, SEM_TYPOGRAPHY_ACTION_LG_LABEL, SEM_TYPOGRAPHY_ACTION_SM_LABEL, SYS_SPACE_FIXED_100, getTypographyStyles, SYS_SIZE_FIXED_1200, SYS_SIZE_FIXED_1400 } from '@oneaudi/unified-web-common';
export const StyledIconButtonLabel = styled.span `
  color: ${(props) => props.theme.cmp.color.action.iconButton.primary.foreground.text.default};

  ${(props) => getTypographyStyles(props.size === 'sm'
    ? SEM_TYPOGRAPHY_ACTION_SM_LABEL
    : SEM_TYPOGRAPHY_ACTION_LG_LABEL)};

  text-align: center;

  // TODO: token missing
  transition-timing-function: cubic-bezier(0.75, 0.02, 0.5, 1);
  transition-duration: 250ms;
  transition-property: color, background-color, box-shadow, border-radius;
`;
export const StyledIconButton = styled.button `
  padding: 0;
  background-color: ${(props) => props.theme.sem.color.action.primary.surface.fill.default};
  color: ${(props) => props.theme.sem.color.action.primary.foreground.text.default};
  border: 1px solid
    ${(props) => props.theme.sem.color.action.primary.surface.stroke.default};
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${SYS_SIZE_FIXED_1200};
  height: ${SYS_SIZE_FIXED_1200};

  ${(props) => {
    if (props.disabled && !props.isLoading) {
        return css `
        cursor: not-allowed;
      `;
    }
    if (props.isLoading) {
        return css `
        cursor: progress;
      `;
    }
    return css `
      cursor: pointer;
    `;
}}

  // TODO: token missing
  transition-timing-function: cubic-bezier(0.75, 0.02, 0.5, 1);
  transition-duration: 250ms;
  transition-property: color, background-color, box-shadow, border-radius;

  ${(props) => props.as === 'a' &&
    css `
      box-sizing: border-box;
    `}

  ${(props) => props.size === 'md' &&
    css `
      width: ${SYS_SIZE_FIXED_1400};
      height: ${SYS_SIZE_FIXED_1400};
    `}

    ${(props) => !props.isLoading &&
    css `
      &:active {
        background-color: ${props.theme.sem.color.action.primary.surface.fill
        .pressed};
        color: ${props.theme.sem.color.action.primary.foreground.text.pressed};

        & + ${StyledIconButtonLabel} {
          color: ${props.theme.cmp.color.action.iconButton.primary.foreground
        .text.pressed};
        }
      }
    `}

  ${(props) => props.as === 'button' &&
    !props.isLoading &&
    css `
      &:disabled {
        background-color: ${props.theme.sem.color.action.primary.surface.fill
        .disabled};
        color: ${props.theme.sem.color.action.primary.foreground.text.disabled};

        & + ${StyledIconButtonLabel} {
          color: ${props.theme.cmp.color.action.iconButton.primary.foreground
        .text.disabled};
        }
      }
    `}

  ${(props) => props.variant === 'secondary' &&
    css `
      background-color: ${props.theme.sem.color.action.secondary.surface.fill
        .default};
      color: ${props.theme.sem.color.action.secondary.foreground.text.default};
      border: 1px solid
        ${props.theme.sem.color.action.secondary.surface.stroke.default};

      ${!props.isLoading &&
        css `
        &:active {
          background-color: ${props.theme.sem.color.action.secondary.surface
            .fill.pressed};
          color: ${props.theme.sem.color.action.secondary.foreground.text
            .pressed};
          & + ${StyledIconButtonLabel} {
            color: ${props.theme.cmp.color.action.iconButton.secondary
            .foreground.text.pressed};
          }
        }
      `}

      ${props.as === 'button' &&
        !props.isLoading &&
        css `
        &:disabled {
          background-color: ${props.theme.sem.color.action.secondary.surface
            .fill.disabled};
          color: ${props.theme.sem.color.action.secondary.foreground.text
            .disabled};
          border-color: ${props.theme.sem.color.action.secondary.surface.stroke
            .disabled};

          & + ${StyledIconButtonLabel} {
            color: ${props.theme.cmp.color.action.iconButton.secondary
            .foreground.text.disabled};
          }
        }
      `}
    `}

  ${(props) => props.variant === 'tertiary' &&
    css `
      background-color: ${props.theme.sem.color.action.tertiary.surface.fill
        .default};
      color: ${props.theme.sem.color.action.tertiary.foreground.text.default};
      border: 1px solid
        ${props.theme.sem.color.action.tertiary.surface.stroke.default};

      ${!props.isLoading &&
        css `
        &:active {
          background-color: ${props.theme.sem.color.action.tertiary.surface.fill
            .pressed};
          color: ${props.theme.sem.color.action.tertiary.foreground.text
            .pressed};
          & + ${StyledIconButtonLabel} {
            color: ${props.theme.cmp.color.action.iconButton.tertiary.foreground
            .text.pressed};
          }
        }
      `}

      ${props.as === 'button' &&
        !props.isLoading &&
        css `
        &:disabled {
          background-color: ${props.theme.sem.color.action.tertiary.surface.fill
            .disabled};
          color: ${props.theme.sem.color.action.tertiary.foreground.text
            .disabled};

          & + ${StyledIconButtonLabel} {
            color: ${props.theme.cmp.color.action.iconButton.tertiary.foreground
            .text.disabled};
          }
        }
      `}
    `}

  ${(props) => props.isLoading &&
    css `
      border-radius: 50%;
      border: none;
    `}
`;
export const StyledIconButtonContainer = styled.div `
  margin: ${(props) => getMargins(props.margin)};
  display: flex;
  flex-direction: column;
  align-items: center;
  width: min-content;
  gap: ${SYS_SPACE_FIXED_100};

  transition-timing-function: cubic-bezier(0.75, 0.02, 0.5, 1);
  transition-duration: 250ms;
  transition-property: color, background-color, box-shadow, border-radius,
    border-color;

  ${(props) => !props.isLoading &&
    css `
      &:hover {
        & ${StyledIconButton}:not(:disabled) {
          background-color: ${props.theme.sem.color.action.primary.surface.fill
        .hover};
          color: ${props.theme.sem.color.action.primary.foreground.text.hover};

          + ${StyledIconButtonLabel} {
            color: ${props.theme.cmp.color.action.iconButton.primary.foreground
        .text.hover};
          }
        }
      }

      &:active {
        & ${StyledIconButton}:not(:disabled) {
          background-color: ${props.theme.sem.color.action.primary.surface.fill
        .pressed};
          color: ${props.theme.sem.color.action.primary.foreground.text
        .pressed};

          + ${StyledIconButtonLabel} {
            color: ${props.theme.cmp.color.action.iconButton.primary.foreground
        .text.pressed};
          }
        }
      }
    `}

  ${(props) => props.variant === 'secondary' &&
    !props.isLoading &&
    css `
      &:hover {
        & ${StyledIconButton}:not(:disabled) {
          background-color: ${props.theme.sem.color.action.secondary.surface
        .fill.hover};
          color: ${props.theme.sem.color.action.secondary.foreground.text
        .hover};
          border-color: ${props.theme.sem.color.action.secondary.surface.stroke
        .hover};

          + ${StyledIconButtonLabel} {
            color: ${props.theme.cmp.color.action.iconButton.secondary
        .foreground.text.hover};
          }
        }
      }

      &:active {
        & ${StyledIconButton}:not(:disabled) {
          background-color: ${props.theme.sem.color.action.secondary.surface
        .fill.pressed};
          color: ${props.theme.sem.color.action.secondary.foreground.text
        .pressed};
          border-color: ${props.theme.sem.color.action.secondary.surface.stroke
        .pressed};
        }

        + ${StyledIconButtonLabel} {
          color: ${props.theme.cmp.color.action.iconButton.secondary.foreground
        .text.pressed};
        }
      }
    `};

  ${(props) => props.variant === 'tertiary' &&
    !props.isLoading &&
    css `
      &:hover {
        & ${StyledIconButton}:not(:disabled) {
          background-color: ${props.theme.sem.color.action.tertiary.surface.fill
        .hover};
          color: ${props.theme.sem.color.action.tertiary.foreground.text.hover};

          + ${StyledIconButtonLabel} {
            color: ${props.theme.cmp.color.action.iconButton.tertiary.foreground
        .text.hover};
          }
        }
      }

      &:active {
        & ${StyledIconButton}:not(:disabled) {
          background-color: ${props.theme.sem.color.action.tertiary.surface.fill
        .pressed};
          color: ${props.theme.sem.color.action.tertiary.foreground.text
        .pressed};
        }

        + ${StyledIconButtonLabel} {
          color: ${props.theme.cmp.color.action.iconButton.tertiary.foreground
        .text.pressed};
        }
      }
    `}
`;
//# sourceMappingURL=index.styles.js.map